// @flow

// This is in a separate file to be shared between the Markdoc tag and
// the React component.

export const IDENTIFIER_MAP = {
  inventory: {
    id: '{{INVENTORY_ID}}',
  },
  customer: {
    id: '{{CUSTOMER_ID}}',
  },
  paymentMethod: {
    id: '{{PAYMENT_METHOD_ID}}',
  },
  price: {
    id: '{{PRICE_ID}}',
  },
  product: {
    id: '{{PRODUCT_ID}}',
  },
  coupon: {
    id: '{{COUPON_ID}}',
  },
  partner: {
    id: '{{PARTNER_ID}}',
  },
  connectedAccount: {
    id: '{{CONNECTED_ACCOUNT_ID}}',
  },
  location: {
    id: '{{LOCATION_ID}}',
  },
  file: {
    id: '{{FILE_ID}}',
  },
  dispute: {
    id: '{{DISPUTE_ID}}',
  },
  paymentIntent: {
    id: '{{PAYMENT_INTENT_ID}}',
  },
  paymentRefund: {
    id: 'pyr_1000000',
  },
  taxCode: {
    id: 'txcd_10000000',
  },
  account: {
    id: '{{ACCOUNT_ID}}',
  },
  session: {
    id: '{{SESSION_ID}}',
  },
};

export const identifierMarkdocFunctionToPlaceholder = (value: string) => {
  if (IDENTIFIER_MAP[value]) {
    return `$$_RESOURCE_${value}$$`;
  } else {
    return `{{RESOURCE_ID}}`;
  }
};

export type IdentifierResourceType = $Keys<typeof IDENTIFIER_MAP>;
